import { isMobile, isPC } from "@modules/util/device"
import { debounce } from "lodash-es"
import { exoClickOnWindowResizeDebounceMs } from "../exoclick/exoclick.ts"
import {
    exoClickBeforePaginationHtmlMobile,
    exoClickBeforePaginationHtmlPc,
    exoClickTemplateDataId,
} from "../exoclick/templates"
import { advertCardsContainerElement } from "../global/dom"

export function rerenderExoClickBeforePagination() {
    if (userData.hasAdFree || !userData.isAgeVerified) {
        return
    }

    // remove existing solads element
    const exoclickElement = document.querySelector(`[data-exoclick-id="${exoClickTemplateDataId}"]`)
    if (exoclickElement) {
        exoclickElement.remove()
    }

    const html = isPC() ? exoClickBeforePaginationHtmlPc() : exoClickBeforePaginationHtmlMobile
    $(html).insertAfter(advertCardsContainerElement())
}

if (!userData.hasAdFree && userData.isAgeVerified) {
    window.addEventListener(
        "orientationchange",
        debounce(() => {
            rerenderExoClickBeforePagination()
        }, exoClickOnWindowResizeDebounceMs),
    )

    // DONT initiate an event listener on resize to rerender solads or exoclick on mobile
    // It will trigger on mobile when scrolling and the browser bar shows/hides. Which triggers a lot of rerenders while scrolling
    // alternative fix would be to check for width changes only.
    if (!isMobile()) {
        window.addEventListener(
            "resize",
            debounce(() => {
                rerenderExoClickBeforePagination()
            }, exoClickOnWindowResizeDebounceMs),
        )
    }
    rerenderExoClickBeforePagination()
}
